export type Locale = "sl" | "en" | "de" | "ru";

export const DEFAULT_LOCALE: Locale = "sl";
export const LOCALES: Locale[] = ["sl", "en", "de", "ru"];
/** @deprecated Locale is determined by the URL path prefix (/en, /de, /ru). */
export const LOCALE_STORAGE_KEY = "nreport-locale";
